// removed by extract-text-webpack-plugin
module.exports = {"Page":"_1SSCojRBpV2hCatU3WoXxY","TitleBar":"_1n_OQyiI8_oCKHfDWluwW8","RightControls":"_19c8vpECGiOQ5-1DTZayvy"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Employees/index.css
// module id = 856
// module chunks = 0